module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "modal-timeline-project-popup"
    }
  }, [_c('div', {
    staticClass: "dimmer",
    on: {
      "click": _vm.onDimmerClick
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "popup"
  }, [_c('p', {
    staticClass: "align-c"
  }, [_c('b', [_vm._v(_vm._s(_vm.project.name))])]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "grid"
  }, [_c('div', {
    staticClass: "col m50"
  }, [_c('inputfield', {
    attrs: {
      "label": "Startdato (dd-mm-ååååå)"
    }
  }, [_c('input', {
    ref: "project_start_date",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": _vm.project.start_date
    },
    on: {
      "change": function($event) {
        return _vm.updateProject(_vm.project, 'start_date')
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "col m50"
  }, [_c('inputfield', {
    attrs: {
      "label": "Afslutningsdato (dd-mm-ååååå)"
    }
  }, [_c('input', {
    ref: "project_end_date",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": _vm.project.end_date
    },
    on: {
      "change": function($event) {
        return _vm.updateProject(_vm.project, 'end_date')
      }
    }
  })])], 1)]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "grid"
  }, [_c('div', {
    staticClass: "col m50"
  }, [_c('inputfield', {
    attrs: {
      "label": "Opgave færdig %"
    }
  }, [_c('input', {
    ref: "project_done_pct",
    attrs: {
      "type": "number",
      "min": "0",
      "max": "100"
    },
    domProps: {
      "value": _vm.project.done_pct
    },
    on: {
      "change": function($event) {
        return _vm.updateProject(_vm.project, 'done_pct')
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "col m50"
  }, [_c('inputfield', {
    attrs: {
      "label": "Status"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.project.status),
      expression: "project.status"
    }],
    ref: "project_status",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.project, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.updateProjectStatus]
    }
  }, _vm._l((_vm.globals.projectStatuses), function(status, key, i) {
    return _c('option', {
      domProps: {
        "value": key
      }
    }, [_vm._v(_vm._s(status.title))])
  }), 0)])], 1)]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "btn color2 block full",
    attrs: {
      "href": '#/project/' + _vm.project['.key']
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v("\n\t\t\tGå til opgave\n\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "close-btn",
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_vm._v("X")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-70c02484","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/modal-timeline-project-popup.vue
// module id = 610
// module chunks = 1